export default __webpack_public_path__ + "static/media/CircleArrowRightFill.2c54853a.svg";